import React, {useEffect, useState} from "react";
import {registerLocale} from "react-datepicker";
import ru from 'date-fns/locale/ru';
import "react-datepicker/dist/react-datepicker.css";
import {IFilter} from "../../interface/Basic/window";
import {range} from "../../utils/date";
import styled from "styled-components/macro";
import {DateSelector} from "../Select/DateSelector";
import {ChangeDateError} from "../../components/ui/InputSearch";
import moment, {Moment} from "moment";
import {useTranslation} from "react-i18next";
import {LanguageEnum} from "../../enum/language";
registerLocale('ru', ru)

interface IDatePickerProps {
    error: string
    initDate: Moment | null
    maxDate?: Moment | null
    minDate?: Moment | null
    yearsReverse?: boolean

    onChange(value: Moment): void
}

const reverseRange = (a: number, b: number) => {
    return range(a, b).reverse()
}

export const DatePicker = ({initDate, onChange, error, maxDate, minDate, yearsReverse}: IDatePickerProps) => {

    const [day, setDay] = useState<IFilter | null>(null);
    const [month, setMonth] = useState<IFilter | null>(null);
    const [year, setYear] = useState<IFilter | null>(null);
    const [days, setDays] = useState<IFilter[]>(reverseRange(1, 32))
    const {i18n, t} = useTranslation();

    useEffect(() => {
        if (i18n.language === LanguageEnum.Ru) {
           moment.locale('ru')
            return
        }
        if (i18n.language === LanguageEnum.En) {
           moment.locale('en')
            return
        }

    },[i18n.language])
    useEffect(() => {
        if (initDate) {
            setDay(days.find(i => +i.name === initDate.get('date')) || null)
            setMonth(months.find(i => i.id === initDate.get('month')) || null)
            setYear(years.find(i => +i.name === initDate.get('year')) || null)
        } else {
            setDay(null)
            setMonth(null)
            setYear(null)
        }
    }, [initDate])

    useEffect(() => {
        if (year && month) {
            setDays(reverseRange(1, +moment()
                .set('year', parseInt(year.name))
                .set('month', month.id)
                .endOf('month')
                .format('DD') + 1))
        } else {
            setDays(reverseRange(1, 32))
        }
    }, [day, month, year])

    const years: IFilter[] = range((minDate?.get('year')) ?? (moment().get('year') - 100), (maxDate ? maxDate?.get('year')+101 : (moment().get('year') + 1)));

    const monthNames = moment.months()

    const months: IFilter[] = [
        {id: 0, name: monthNames[0] ?? "Январь"},
        {id: 1, name: monthNames[1] ?? "Февраль"},
        {id: 2, name: monthNames[2] ?? "Март"},
        {id: 3, name: monthNames[3] ?? "Апрель"},
        {id: 4, name: monthNames[4] ?? "Май"},
        {id: 5, name: monthNames[5] ?? "Июнь"},
        {id: 6, name: monthNames[6] ?? "Июль"},
        {id: 7, name: monthNames[7] ?? "Август"},
        {id: 8, name: monthNames[8] ?? "Сентябрь"},
        {id: 9, name: monthNames[9] ?? "Октябрь"},
        {id: 10, name: monthNames[10] ?? "Ноябрь"},
        {id: 11, name: monthNames[11] ?? "Декабрь"},
    ];
    const changeDate = (day: number, month: number, year: number) => {
        const lastDayOfMonth = moment().set('year', year).set('month', month).endOf('month').format('DD')
        const dayParsed = day > parseInt(lastDayOfMonth) ? parseInt(lastDayOfMonth) : day
        onChange(moment().set({year: year, month: month, date: dayParsed}))
    }

    const monthName = month?.name
        ? month?.name.substring(0,1).toUpperCase() + month.name.substring(1).toLowerCase()
        : undefined

    return <DatePickerContainer>
        <DateSelector
            className={'days'}
            items={days}
            selectedItem={day?.name}
            placeholder={t('passport.registrationForm.birthdateForm.day')}
            onSelect={(item) => {
                if (month && year) {
                    changeDate(parseInt(item.name), month.id, parseInt(year.name))
                } else {
                    setDay(item)
                }
            }}/>
        <DateSelector
            className={'months'}
            items={months}
            selectedItem={monthName}
            placeholder={t('passport.registrationForm.birthdateForm.month')}
            onSelect={(item) => {
                if (day && year) {
                    changeDate(parseInt(day.name), item.id, parseInt(year.name))
                } else {
                    setMonth(item)
                }

            }}/>
        <DateSelector
            className={'years'}
            items={yearsReverse ? years.reverse() : years}
            selectedItem={year?.name}
            placeholder={t('passport.registrationForm.birthdateForm.year')}
            onSelect={(item) => {
                if (day && month) {
                    changeDate(parseInt(day.name), month.id, parseInt(item.name))
                } else {
                    setYear(item)
                }
            }}/>
        <ChangeDateError error={error}>
            {error}
        </ChangeDateError>
    </DatePickerContainer>
};


export const DatePickerContainer = styled.label`
  display: flex;
  position: relative;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  height: 40px;

  input {
    background-color: ${({theme}) => theme.color.primaryBackground};
    cursor: pointer;
  }
`
